import { useEffect } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import WhatsAppButton from '../../components/feature/WhatsAppButton';
import EnquiryHero from './components/EnquiryHero';
import EnquiryForm from './components/EnquiryForm';

const Enquiry = () => {
  useEffect(() => {
    window.scrollTo(0, 0);

    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

    // Set document title
    document.title = 'Contact Us - Get in Touch | GrowthLink Marketing Solutions';

    // Set meta tags
    const metaTags = [
      { name: 'description', content: 'Contact GrowthLink for expert digital marketing solutions. Reach us via email at growthlink2705@gmail.com, WhatsApp at +91 8931893177, or submit an enquiry form. Our team is ready to help accelerate your business growth with customized marketing strategies.' },
      { name: 'keywords', content: 'contact GrowthLink, digital marketing enquiry, marketing consultation, get in touch' },
      { property: 'og:title', content: 'Contact Us - Get in Touch | GrowthLink Marketing Solutions' },
      { property: 'og:description', content: 'Contact GrowthLink for expert digital marketing solutions. Reach us via email, WhatsApp, or submit an enquiry form.' },
      { property: 'og:url', content: `${siteUrl}/enquiry` },
      { name: 'twitter:title', content: 'Contact Us - Get in Touch | GrowthLink Marketing Solutions' },
      { name: 'twitter:description', content: 'Contact GrowthLink for expert digital marketing solutions. Reach us via email, WhatsApp, or submit an enquiry form.' },
    ];

    metaTags.forEach(({ name, property, content }) => {
      const attribute = name ? 'name' : 'property';
      const value = name || property;
      let meta = document.querySelector(`meta[${attribute}="${value}"]`);
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute(attribute, value!);
        document.head.appendChild(meta);
      }
      meta.setAttribute('content', content);
    });

    // Set canonical link
    let canonical = document.querySelector('link[rel="canonical"]') as HTMLLinkElement;
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.rel = 'canonical';
      document.head.appendChild(canonical);
    }
    canonical.href = `${siteUrl}/enquiry`;

    // Set JSON-LD schema
    const schemaData = {
      "@context": "https://schema.org",
      "@type": "ContactPage",
      "name": "Contact GrowthLink",
      "description": "Get in touch with GrowthLink for digital marketing solutions. Contact us via email, WhatsApp, or submit an enquiry form.",
      "url": `${siteUrl}/enquiry`,
      "mainEntity": {
        "@type": "Organization",
        "name": "GrowthLink",
        "email": "growthlink2705@gmail.com",
        "telephone": "+91-8931893177",
        "address": {
          "@type": "PostalAddress",
          "addressCountry": "IN",
          "addressLocality": "India"
        }
      }
    };

    let script = document.querySelector('script[type="application/ld+json"]');
    if (!script) {
      script = document.createElement('script');
      script.type = 'application/ld+json';
      document.head.appendChild(script);
    }
    script.textContent = JSON.stringify(schemaData);

    return () => {
      // Cleanup is optional for meta tags as they'll be updated on next page
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main className="pt-20">
        <EnquiryHero />
        <EnquiryForm />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
};

export default Enquiry;
